import request from "./api-interceptor";

const contactService = {
  create: (data) => request.post("api/v1/contact", data),
};

export default contactService;
